import { DatePipe } from '@angular/common'
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Portfolio } from 'src/app/features/portfolio/portfolio.model'
import { FundCharacteristic } from 'src/app/models/characteristic-response.model'
import { Footnote } from 'src/app/models/footnote.model'

@Component({
  selector: 'fund-characteristic',
  templateUrl: './fund-characteristic.component.html',
  styleUrls: ['./fund-characteristic.component.scss'],
  providers: [],
})
export class FundCharacteristicComponent implements OnInit {
  @ViewChild('simpleDialogContent') simpleDialogContent: TemplateRef<any>
  @Input() portfolioModel: Portfolio
  @Input() fundId: string
  @Input() benchmarkFootNote: Footnote
  @Input() portfolioFootNote: Footnote
  fundCharacteristic: FundCharacteristic
  noCharacteristicsData = false
  public title = ''
  public datePipe: DatePipe

  constructor(private readonly viewContainer: ViewContainerRef) {
    this.datePipe = new DatePipe('en-US')
  }
  // eslint-disable-next-line complexity
  ngOnInit(): void {
    this.fundCharacteristic =
      this.portfolioModel !== null &&
      this.portfolioModel !== undefined &&
      this.portfolioModel.characteristic !== null &&
      this.portfolioModel.characteristic !== undefined &&
      this.portfolioModel.characteristic.fundCharacteristic

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.noCharacteristicsData =
      Object.keys(this.fundCharacteristic).length === 0 ? true : false
  }

  public openUpDialog(type = ' ') {
    this.title = type
    //openDialog
  }
}
